module.exports = __webpack_public_path__ + "resources/img/logo_oti.7a6ded64fac44b3ce9e09cc2a08e3894.png";